export const useEmphasisText = () => {
  return {
    components: [<span className="font-semibold" />],
    parent: 'p',
  };
};
